// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTreatmentSummary_root__2u1fw","row":"ProcedureTreatmentSummary_row__3OFqS"};